<template>
  <div
    class="item-container"
    v-bind:id="[
      !selectedCause || (!partNumber && showErrors) ? 'container-error' : ''
    ]"
  >
    <div class="item-header">
      <button class="remove-item" @click="removeItem()"></button>
    </div>
    <div class="item-content">
      <div class="first-row-content">
        <div class="amount">
          <div class="select-container">
            <label>Quantidade de Items Iguais</label>
            <div>
<!--              <input type="text" class="select-cause" @keypress="onlyNumber" value="1">-->
              <input type="number" class="select-cause" value="1" v-model="quantity">
            </div>
          </div>
        </div>
        <div class="partnumber">
          <label :for="getDynamicNameItem('item-part-number')"
            >Part Number</label
          >
          <AutoComplete
            :id="id"
            :invoiceIndex="invoiceIndex"
            @itemSelected="updateInfo($event)"
            @itemCleared="clearItem()"
            :selectItemsList="selectItemsList"
          />
          <span class="error-text" v-if="!partNumber && showErrors"
            >*Part number inválido</span
          >
        </div>

        <div class="fixed-values">
          <div>
            <label :for="getDynamicNameItem('item-material')">Material</label>
            <input
              class="default-input"
              :id="getDynamicNameItem('item-material')"
              v-model="material"
              type="text"
              placeholder="Material"
              disabled
              readonly
            />
          </div>
          <div>
            <label :for="getDynamicNameItem('item-subfamily')"
              >Subfamília</label
            >
            <input
              class="default-input"
              :id="getDynamicNameItem('item-subfamily')"
              v-model="subFamily"
              type="text"
              placeholder="Subfamília"
              disabled
              readonly
            />
          </div>
        </div>
      </div>
      <div class="second-row-content">
        <div class="select-container">
          <label :for="getDynamicNameItem('item-cause')">Motivos</label>
          <div class="select-cause">
            <select
              v-model="selectedCause"
              :id="getDynamicNameItem('item-cause')"
            >
              <option value disabled selected>Selecione</option>
              <option v-for="cause in causesFilter()" :key="cause.id">{{
                getCauseFullName(cause)
              }}</option>
            </select>
            <span class="error-text" v-if="!selectedCause && showErrors"
              >*Selecione um motivo</span
            >
          </div>
        </div>
        <div class="specific-values">
          <SpecificFields
            v-for="item in this.spFields"
            :key="item.id"
            :id="id"
            :invoiceIndex="invoiceIndex"
            :cause="selectedCause"
            @updateFields="updateFieldsStatus($event)"
            @sendSpecificFieldsData="updateSpecificFieldsData($event)"
            :subFamily="subFamily"
            :isGettingSpecificFieldsData="isGettingSpecificFieldsData"
          />
        </div>
        <button class="clear-inputs" @click="clearField()">Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/eventHub";
import CauseService from "@/services/return-solicitation/cause-service.js";
import SpecificFields from "@/components/home/return-solicitation/SpecificFields.vue";
import AutoComplete from "@/components/home/return-solicitation/AutoComplete.vue";
import CompressorCauses from "@/services/return-solicitation/compressor-causes-service.js";

export default {
  watch: {
    isGettingItemData: function() {
      this.isGettingSpecificFieldsData = this.isGettingItemData;
    },
    quantity: function(val) {
      if ((val >= 1 && val <= 100) || val == '') {
        this.quantity = val
        this.addSpecificFields(this.quantity)
      } else {
        this.quantity = 1;
        this.addSpecificFields(this.quantity)
      }
    }
  },
  name: "Item",
  components: {
    SpecificFields,
    AutoComplete
  },
  data: function() {
    return {
      partNumber: "",
      material: "",
      subFamily: "",
      selectedCause: "",
      causesList: [],
      compressorCausesIds: [],
      showErrors: false,
      fieldsStatus: false,
      isGettingSpecificFieldsData: false,
      quantityOfItems: 1,
      spFields: [{ id : 1, status: false}],
      maxquantity: 100,
      quantity: 1
    };
  },
  props: {
    id: Number,
    invoiceIndex: Number,
    isGettingItemData: Boolean,
    selectItemsList: Array
  },
  methods: {
    clearField() {
      this.material = "";
      this.subFamily = "";
      this.partNumber = "";
      this.selectedCause = "";
      EventBus.$emit("clearField");
    },
    onlyNumber(event) {
      if (!/\d/.test(event.key) || parseInt(`${event.target.value}${event.key}`) > this.maxquantity || parseInt(`${event.target.value}${event.key}`) < 1) {
        return event.preventDefault();
      }
      //this.quantityOfItems = parseInt(`${event.target.value}${event.key}`)
      this.addSpecificFields(parseInt(`${event.target.value}${event.key}`))
    },
    addSpecificFields(quantity){
      let spq = this.spFields.length
      if(spq < quantity){
        let total = quantity - spq
        let count = 1
        for(let i = 0; i < total; i++){
          this.spFields.push({ id : spq + count, status: false})
          count++
        }
      }else{
        let total = spq - quantity
        for(let i = 0; i < total; i++){
          this.spFields.pop()
        }
      }
    },
    updateInfo(item) {
      this.material = item.name;
      this.subFamily = item.subfamily;
      this.partNumber = item.part_number;
    },
    getDynamicNameItem(name) {
      return `${this.invoiceIndex + 1}-invoice-${name}-input-${this.id + 1}`;
    },
    removeItem() {
      this.$emit("deleteItem");
    },
    causesFilter() {
      if (this.subFamily == "Compressores Herméticos Embraco") {
        return this.causesList.filter(
          cause => this.compressorCausesIds.indexOf(cause.id) !== -1
        );
      }
      return this.causesList;
    },
    getCauseFullName(cause) {
      return `${cause.id} - ${cause.description}`;
    },
    sendItemStatus() {
      this.$emit(
        "updateItem",
        this.partNumber && this.selectedCause && this.fieldsStatus
      );
    },
    updateFieldsStatus(status) {
      let index = this.spFields.findIndex( field => { return field.id == status.id  })
      this.spFields[index].status = status.status

      let finalStatus = true
      for(let i = 0; i < this.spFields.length; i ++ ){
        if(!this.spFields[i].status){
          finalStatus = false
          break
        }
      }
      this.fieldsStatus = finalStatus;
      this.sendItemStatus();
    },
    updateSpecificFieldsData(data) {
      const causeId = parseInt(this.selectedCause.split(" ")[0]);
      const causeDescription = this.causesList.find(
        cause => cause.id == causeId
      ).description;

      this.$emit("updateItemData", {
        id_return_request: "",
        count: 1,
        id_invoice: "",
        partnumber: this.partNumber,
        material: this.material,
        subFamily: this.subFamily,
        cause: {
          cause_code: causeId,
          text: causeDescription
        },
        specific_fields: data
      });
    }
  },
  created() {
    EventBus.$on("sendClicked", () => {
      this.showErrors = true;
      this.sendItemStatus();
    });

    CauseService.getCauseList().then(({ data }) => {
      this.causesList = data
    });

    CompressorCauses.getCauseCodeBySubfamily().then(({ data }) => {
      data.forEach(item => {
        this.compressorCausesIds.push(item.cause_code)
      })
    });
  },
  updated() {
    this.sendItemStatus();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.item-container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 13px;
  padding-right: 13px;
  margin-top: 20px;

  .item-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 25px;
    width: 100%;
    padding-right: 13px;
    background-color: $orange1;

    .remove-item {
      height: 3px;
      width: 20px;
      background: $white;
      outline: none;
      border: none;
      cursor: pointer;

      &:hover {
        transition: 0.7s;
        background: $grey1;
      }
    }
  }

  .item-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $grey7;

    .first-row-content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;

      .amount{
        padding-top: 20px;
        padding-left: 13px;
        padding-bottom: 10px;
        box-sizing: border-box;
      }

      .partnumber {
        padding-top: 0px;
        padding-left: 13px;
        padding-bottom: 10px;
        box-sizing: border-box;
      }

      .fixed-values {
        display: flex;
        flex-direction: column;
        padding-left: 13px;
        padding-bottom: 10px;
        box-sizing: border-box;

        & > div {
          display: flex;
          flex-direction: column;
          width: 53.5%;
          margin-right: 20px;
          margin-top: 10px;

          & > input {
            width: 90%;
            cursor: not-allowed;
          }
        }
      }

      .select-cause {
        background-color: $white;
        border: 1px solid $grey3;
        width: 50%;
        height: 37px;
        margin-top: 3px;
        box-sizing: border-box;

      }
    }

    .second-row-content {
      display: flex;
      flex-direction: column;
      width: 100%;

      .select-container {
        width: 100%;
        padding-left: 13px;
        padding-top: 10px;
        padding-bottom: 20px;
        box-sizing: border-box;

        .select-cause {
          background-color: $white;
          border: 1px solid $grey3;
          width: 50%;
          height: 37px;
          margin-top: 3px;
          box-sizing: border-box;

          & > select {
            width: 100%;
            height: 37px;
            margin: 0;
            padding: 5px;
            background: none;
            border: none;
            color: $grey2;
            font-size: 14px;
            outline: none;
            cursor: pointer;
          }
        }
      }

      .specific-values {
        box-sizing: border-box;
      }
    }
  }
  .clear-inputs {
    height: 36px;
    width: 80px;
    margin: 10px 0 15px 15px;
    text-align: center;
    text-transform: uppercase;
    border: none;
    color: $white;
    font-size: 14px;
    background: $grey2;
    outline: none;
    cursor: pointer;

    &:hover {
      transition: 0.7s;
      background-color: $grey1;
    }
  }

  select {
    height: 28px;
    margin-top: 5px;
  }
}
</style>
